import { QuarterlyEarnings } from "../domain/QuarterlyEarnings";

export enum PayFrequency {
    YEARLY = 'Yearly',
    MONTHLY = 'Monthly',
    SEMI_MONTHLY = 'Semi-monthly',
    BI_WEEKLY = 'Bi-weekly',
    WEEKLY = 'Weekly',
    HOURLY = 'Hourly'
}

export function findHourlyEquivalentFor(baseWage: string, hoursWorkedPerWeek: string, payFrequency: PayFrequency): number {
    const wage = parseFloat(baseWage)
    const hoursWorked = parseFloat(hoursWorkedPerWeek);
    let hourlyPay = wage;
    if (payFrequency === PayFrequency.YEARLY) {
        hourlyPay = (wage / 52) / hoursWorked
    } else if (payFrequency === PayFrequency.MONTHLY) {
        hourlyPay = ((wage * 12) / 52) / hoursWorked
    } else if (payFrequency === PayFrequency.SEMI_MONTHLY) {
        hourlyPay = ((wage * 24) / 52) / hoursWorked
    } else if (payFrequency === PayFrequency.BI_WEEKLY) {
        hourlyPay = wage / (hoursWorked * 2)
    } else if (payFrequency === PayFrequency.WEEKLY) {
        hourlyPay = wage / hoursWorked
    }
    return hourlyPay;
}

export function calculateYearlyEarnings(earningsQuarters: QuarterlyEarnings[]): string {
    const quartersInYears = 4 / earningsQuarters.length;
    const totalEarnings = earningsQuarters.reduce((sum, quarter) => {
        const amount = parseFloat(quarter.amount);
        return sum + amount;
    }, 0);

    return (totalEarnings * quartersInYears).toString();
}
